export default __webpack_public_path__ + "static/media/bpolka_dot.b1c877c3.jpg";